import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useSession } from '../hooks/useSession.tsx';
import { useT } from '../i18n/index.ts';
import { useNotificationsSync, useStoredNotices } from '../notifications/useNotifications.ts';
import { Button } from '../ui/index.ts';

/**
 * Header notification bell (tenant #116, 2026-08-21 交互定稿): NO
 * popover — notification content renders only on `/notifications`.
 * Unread state shows as a plain red dot (no count), and clicking the
 * bell navigates to the page. Mounting the bell also mounts the
 * five-minute sync loop, so the dot stays honest on every
 * authenticated screen.
 */
export function ShellBell(): JSX.Element {
  const t = useT();
  const navigate = useNavigate();
  const { user } = useSession();
  const scope = user?.orgId ?? null;
  useNotificationsSync();
  const notices = useStoredNotices(scope);
  const unread = notices.filter((notice) => !notice.read).length;

  return (
    <Button
      variant="ghost"
      aria-label={
        unread > 0 ? t('shell.bell.aria_unread', { count: unread }) : t('shell.bell.aria')
      }
      onClick={() => {
        void navigate('/notifications');
      }}
      data-testid="shell-bell"
      className="relative px-2"
    >
      <Bell aria-hidden="true" className="h-4 w-4" />
      {unread > 0 ? (
        <span
          aria-hidden="true"
          data-testid="shell-bell-dot"
          className="absolute right-1 top-1 h-2 w-2 rounded-full bg-bad"
        />
      ) : null}
    </Button>
  );
}
